<template>
    <g fill-rule="evenodd">
        <path d="M1.51 3.343h36.98c.834 0 1.51-.666 1.51-1.486S39.324.37 38.49.37H1.51C.675.37 0 1.038 0 1.858c0 .82.676 1.486 1.51 1.486zM1.51 14.486h36.98c.834 0 1.51-.666 1.51-1.486s-.676-1.486-1.51-1.486H1.51C.675 11.514 0 12.18 0 13s.676 1.486 1.51 1.486zM1.51 25.63h36.98c.834 0 1.51-.667 1.51-1.487 0-.82-.676-1.486-1.51-1.486H1.51c-.834 0-1.51.666-1.51 1.486s.676 1.486 1.51 1.486z"/>
    </g>
</template>

<script>
export default {
    name: 'backIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 40 26');
    }
}
</script>
